import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

export default createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      alignSelf: 'flex-start',
      marginInlineEnd: 24,
      position: 'sticky',
      top: 150,

      [mediaQuery(breakpoints.tablet)]: {
        display: 'none',
      },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    entry: {
      alignItems: 'center',
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 72,
      border: '1px solid var(--x-border-4)',
      color: 'var(--x-black-1)',
      display: 'flex',
      fontWeight: 600,
      gap: 8,
      minHeight: 40,
      outline: 'none',
      paddingLeft: 24,
      textDecoration: 'none',
    },
    entrySelected: {
      color: 'var(--x-accent-1-1)',
      backgroundColor: '#F6E8F1',
      border: '1px solid var(--x-accent-1-1)',

      '&>svg': {
        fill: 'var(--x-accent-1-1)',
      },
    },
    heading: {
      color: 'var(--x-black)',
      fontWeight: 600,
      fontSize: 14,
      lineHeight: '16px',
      marginBlockEnd: 16,
    },
    icon: {
      fill: 'var(--x-black)',
    },
    link: {
      display: 'flex',
      gap: 8,
    },
  }),
  { name: 'Categories' },
);
